// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"l--z","button":"m--z","disabled":"n--z","creditCard":"o--z","wrapper":"p--z"};